module.exports = __webpack_public_path__ + "img/half-stars-1.12e3b0fd.svg";